<template>
    <div class="papsi-wrapper">
        <div class="papsi-wrapper flex justify-between">
            <div>
                <h1 class="text-2xl font-semibold text-[#24723b]">HR Request Form</h1>
                <p  class="text-xs text-[#747474] mt-2">Home / OHR Form Request</p>
            </div>
            <div >
                <button  class="py-3 px-5 rounded-md text-sm mr-5 w-[200px] shadow-lg font-semibold border border-[#a8a7a7] hover:bg-[#444]" @click="activeBtn = 'Button1'" v-bind:class="{active: activeBtn === 'Button1' , notactive: activeBtn === 'Button2'}">Request Status</button>
                <button  class="py-3 px-5 rounded-md text-sm w-[200px] shadow-lg font-semibold border border-[#a8a7a7] hover:bg-[#444]"  @click="activeBtn = 'Button2'" v-bind:class="{active: activeBtn === 'Button2', notactive: activeBtn === 'Button1'}">Finished Requests</button>
            </div>
        </div>
    </div>
    <div class="mt-11">
        <div class="mt-8 bg-[#f0f0f0] border-[#ffffff41] border-[3px] p-3 rounded-md shadow">
            <TableControl :Action="true" v-if="activeBtn === 'Button1'" :header="header" :column="column" :info="info" :VButton="true" :EButton="false" :DButton="false" @EditButton="EditButton" @DeleteButton="DeleteButton" @ViewButton="ViewButton" />                
            <TableControl :Action="true" v-if="activeBtn === 'Button2'" :header="header1" :column="columnapproved" :VButton="true" :info="infoapproved" :EButton="false" :DButton="false" @EditButton="EditButton" @DeleteButton="DeleteButton"  @ViewButton="ViewButton"/>                
        </div>
    </div>
    
    <div>
        <Transition
            enter-active-class="transition duration-200 ease-out"
            enter-from-class="opacity-0"
            enter-to-class="opacity-100"
            leave-active-class="transition duration-150 ease-in"
            leave-from-class="opacity-100"
            leave-to-class="opacity-0">
            <div
                v-if="test"
                    class="fixed inset-0 z-[9999] flex items-end justify-center bg-black/50 backdrop-blur-[3px] sm:items-center sm:px-4 sm:py-6"
                    role="dialog"
                    aria-modal="true"
                    aria-labelledby="ohr-request-title"
                @click.self="test = false">
                <Transition
                    appear
                    enter-active-class="transition duration-300 ease-out"
                    enter-from-class="translate-y-full opacity-0 sm:translate-y-4 sm:scale-95"
                    enter-to-class="translate-y-0 opacity-100 sm:scale-100"
                    leave-active-class="transition duration-200 ease-in"
                    leave-from-class="translate-y-0 opacity-100 sm:scale-100"
                    leave-to-class="translate-y-full opacity-0 sm:translate-y-4 sm:scale-95">

                    <div
                        class="flex max-h-[95dvh] w-full flex-col overflow-hidden rounded-t-3xl bg-white shadow-2xl sm:max-h-[90dvh] sm:max-w-2xl sm:rounded-3xl"
                    >
                        <!-- Header -->
                        <div
                            class="relative shrink-0 overflow-hidden bg-gradient-to-r from-[#0B6014] to-[#12760A] px-5 py-4 sm:px-6 sm:py-5"
                        >
                            <div
                                class="absolute -right-12 -top-12 h-36 w-36 rounded-full bg-white/10"
                            ></div>

                            <div
                                class="absolute -bottom-16 right-20 h-28 w-28 rounded-full bg-white/5"
                            ></div>

                            <div
                                class="relative flex items-center justify-between gap-4"
                            >
                                <div
                                    class="flex min-w-0 items-center gap-3 sm:gap-4"
                                >
                                    <div
                                        class="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-white/15 ring-1 ring-white/20 sm:h-12 sm:w-12"
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            class="h-5 w-5 text-white sm:h-6 sm:w-6"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                            stroke-width="1.8"
                                        >
                                            <path
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                d="M9 12h6m-6 4h6M7 3h7l4 4v14H6V4a1 1 0 011-1z"
                                            />

                                            <path
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                d="M14 3v5h5"
                                            />
                                        </svg>
                                    </div>

                                    <div class="min-w-0">
                                        <h2
                                            id="ohr-request-title"
                                            class="truncate text-base font-bold text-white sm:text-lg"
                                        >
                                            OHR Form Request
                                        </h2>

                                        <p
                                            class="mt-0.5 truncate text-[11px] text-white/75 sm:text-xs"
                                        >
                                            Review the employee request details
                                        </p>
                                    </div>
                                </div>

                                <button
                                    type="button"
                                    class="flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-white/80 transition hover:bg-white/15 hover:text-white"
                                    aria-label="Close modal"
                                    @click="test = false"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        class="h-5 w-5"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                        stroke-width="2"
                                    >
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            d="M6 18L18 6M6 6l12 12"
                                        />
                                    </svg>
                                </button>
                            </div>
                        </div>

                        <!-- Scrollable Body -->
                        <div
                            class="flex-1 overflow-y-auto overscroll-contain px-4 py-5 sm:px-6 sm:py-6"
                        >
                            <!-- Employee Information -->
                            <div
                                class="mb-5 rounded-2xl border border-slate-200 bg-slate-50 p-4 sm:p-5"
                            >
                                <div
                                    class="mb-4 flex items-center gap-2 text-sm font-bold text-slate-700"
                                >
                                    <div
                                        class="flex h-8 w-8 items-center justify-center rounded-lg bg-green-100 text-[#12760A]"
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            class="h-4 w-4"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                            stroke-width="2"
                                        >
                                            <path
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                d="M16 21v-2a4 4 0 00-4-4H6a4 4 0 00-4 4v2"
                                            />

                                            <circle
                                                cx="9"
                                                cy="7"
                                                r="4"
                                            />

                                            <path
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                d="M16 11l2 2 4-4"
                                            />
                                        </svg>
                                    </div>

                                    Employee Information
                                </div>

                                <div
                                    class="grid grid-cols-1 gap-4 sm:grid-cols-2"
                                >
                                    <div>
                                        <p
                                            class="mb-1 text-[11px] font-semibold uppercase tracking-wide text-slate-400"
                                        >
                                            Employee
                                        </p>

                                        <p
                                            class="break-words text-sm font-semibold text-slate-700"
                                        >
                                            {{
                                                data.employee_name ||
                                                "Not available"
                                            }}
                                        </p>
                                    </div>

                                    <div>
                                        <p
                                            class="mb-1 text-[11px] font-semibold uppercase tracking-wide text-slate-400"
                                        >
                                            Date Submitted
                                        </p>

                                        <p
                                            class="text-sm font-semibold text-slate-700"
                                        >
                                            {{
                                                data.date_submitted ||
                                                "Not available"
                                            }}
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <!-- Standard Request -->
                            <div
                                v-if="
                                    data.remarks?.substring(0, 19) !==
                                    'CHANGE CIVIL STATUS'
                                "
                                class="space-y-4"
                            >
                                <!-- Requested Forms -->
                                <div
                                    v-if="
                                        Array.isArray(testser) &&
                                        testser.length > 0
                                    "
                                    class="rounded-2xl border border-slate-200 bg-white p-4 sm:p-5"
                                >
                                    <div
                                        class="mb-3 flex items-center justify-between gap-3"
                                    >
                                        <div class="flex items-center gap-2">
                                            <div
                                                class="flex h-8 w-8 items-center justify-center rounded-lg bg-green-100 text-[#12760A]"
                                            >
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    class="h-4 w-4"
                                                    fill="none"
                                                    viewBox="0 0 24 24"
                                                    stroke="currentColor"
                                                    stroke-width="2"
                                                >
                                                    <path
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                        d="M9 11l3 3L22 4"
                                                    />

                                                    <path
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                        d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"
                                                    />
                                                </svg>
                                            </div>

                                            <p
                                                class="text-sm font-bold text-slate-700"
                                            >
                                                Requested Forms
                                            </p>
                                        </div>

                                        <span
                                            class="rounded-full bg-green-100 px-2.5 py-1 text-[11px] font-semibold text-[#12760A]"
                                        >
                                            {{ testser.length }}
                                            {{
                                                testser.length === 1
                                                    ? "Request"
                                                    : "Requests"
                                            }}
                                        </span>
                                    </div>

                                    <div class="space-y-2">
                                        <div
                                            v-for="(row, index) in testser"
                                            :key="index"
                                            class="flex items-start gap-3 rounded-xl bg-slate-50 px-3 py-2.5"
                                        >
                                            <span
                                                class="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-green-100 text-[10px] font-bold text-[#12760A]"
                                            >
                                                {{ index + 1 }}
                                            </span>

                                            <p
                                                class="break-words text-sm leading-5 text-slate-600"
                                            >
                                                {{ row.forms }}
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <!-- Other Request -->
                                <div
                                    v-if="
                                        data.oth_reason != null &&
                                        data.oth_reason !== ''
                                    "
                                    class="rounded-2xl border border-amber-200 bg-amber-50 p-4 sm:p-5"
                                >
                                    <div
                                        class="mb-2 flex items-center gap-2"
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            class="h-5 w-5 shrink-0 text-amber-600"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                            stroke-width="2"
                                        >
                                            <path
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                d="M12 9v4m0 4h.01"
                                            />

                                            <path
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                d="M10.3 3.6L1.8 18a2 2 0 001.7 3h17a2 2 0 001.7-3L13.7 3.6a2 2 0 00-3.4 0z"
                                            />
                                        </svg>

                                        <p
                                            class="text-sm font-bold text-amber-800"
                                        >
                                            Other Request
                                        </p>
                                    </div>

                                    <p
                                        class="break-words text-sm leading-6 text-amber-700"
                                    >
                                        {{ data.oth_reason }}
                                    </p>
                                </div>

                                <!-- Reason -->
                                <div
                                    class="rounded-2xl border border-slate-200 bg-white p-4 sm:p-5"
                                >
                                    <div
                                        class="mb-2 flex items-center gap-2"
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            class="h-5 w-5 shrink-0 text-[#12760A]"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                            stroke-width="2"
                                        >
                                            <path
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                d="M8 10h8M8 14h5"
                                            />

                                            <path
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                d="M5 4h14a2 2 0 012 2v12a2 2 0 01-2 2H9l-4 3v-3a2 2 0 01-2-2V6a2 2 0 012-2z"
                                            />
                                        </svg>

                                        <p
                                            class="text-sm font-bold text-slate-700"
                                        >
                                            Reason
                                        </p>
                                    </div>

                                    <p
                                        class="break-words text-sm leading-6 text-slate-600"
                                    >
                                        {{
                                            data.reason ||
                                            "No reason provided."
                                        }}
                                    </p>
                                </div>
                            </div>

                            <!-- Change Civil Status Request -->
                            <div v-else class="space-y-4">
                                <div
                                    class="rounded-2xl border border-slate-200 bg-white p-4 sm:p-5"
                                >
                                    <div
                                        class="mb-2 flex items-center gap-2"
                                    >
                                        <div
                                            class="flex h-8 w-8 items-center justify-center rounded-lg bg-green-100 text-[#12760A]"
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                class="h-4 w-4"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                                stroke-width="2"
                                            >
                                                <path
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                    d="M12 12a4 4 0 100-8 4 4 0 000 8z"
                                                />

                                                <path
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                    d="M6 21v-2a6 6 0 0112 0v2"
                                                />
                                            </svg>
                                        </div>

                                        <p
                                            class="text-sm font-bold text-slate-700"
                                        >
                                            Civil Status Request
                                        </p>
                                    </div>

                                    <p
                                        class="break-words rounded-xl bg-slate-50 px-4 py-3 text-sm leading-6 text-slate-600"
                                    >
                                        {{ data.remarks }}
                                    </p>
                                </div>

                                <!-- Attachment -->
                                <button
                                    type="button"
                                    class="group flex w-full items-center gap-4 rounded-2xl border border-dashed border-green-300 bg-green-50 p-4 text-left transition hover:border-[#12760A] hover:bg-green-100 sm:p-5"
                                    @click="getPdfFile(data.request_key)"
                                >
                                    <div
                                        class="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-white text-[#12760A] shadow-sm transition group-hover:scale-105"
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            class="h-5 w-5"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                            stroke-width="2"
                                        >
                                            <path
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                d="M15.2 7.8l-6.4 6.4a2 2 0 102.8 2.8l7.1-7.1a4 4 0 00-5.6-5.6L6 11.4a6 6 0 108.5 8.5l6-6"
                                            />
                                        </svg>
                                    </div>

                                    <div class="min-w-0 flex-1">
                                        <p
                                            class="text-sm font-bold text-green-800"
                                        >
                                            View File Attachment
                                        </p>

                                        <p
                                            class="mt-0.5 text-xs leading-5 text-green-700/70"
                                        >
                                            Click here to open the submitted
                                            document.
                                        </p>
                                    </div>

                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        class="h-5 w-5 shrink-0 text-green-600 transition group-hover:translate-x-1"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                        stroke-width="2"
                                    >
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            d="M9 18l6-6-6-6"
                                        />
                                    </svg>
                                </button>
                            </div>
                        </div>

                        <!-- Footer -->
                        <div
                            class="shrink-0 border-t border-slate-200 bg-white px-4 pb-[max(1rem,env(safe-area-inset-bottom))] pt-4 sm:px-6 sm:pb-5"
                        >
                            <div
                                class="flex flex-col-reverse gap-2 sm:flex-row sm:justify-end sm:gap-3"
                            >
                                <button
                                    type="button"
                                    class="w-full rounded-xl border border-slate-200 bg-white px-6 py-3 text-sm font-semibold text-slate-600 transition hover:border-slate-300 hover:bg-slate-100 focus:outline-none focus:ring-4 focus:ring-slate-100 sm:w-auto"
                                    @click="test = false"
                                >
                                    Cancel
                                </button>

                                <button
                                    v-if="
                                        activeBtn === 'Button1' &&
                                        data.remarks?.substring(0, 19) !==
                                            'CHANGE CIVIL STATUS'
                                    "
                                    type="button"
                                    class="flex w-full items-center justify-center gap-2 rounded-xl bg-[#12760A] px-6 py-3 text-sm font-semibold text-white shadow-lg shadow-green-900/15 transition hover:bg-[#0B6014] focus:outline-none focus:ring-4 focus:ring-green-200 sm:w-auto"
                                    @click="ReleaseDocument"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        class="h-4 w-4"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                        stroke-width="2"
                                    >
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            d="M5 13l4 4L19 7"
                                        />
                                    </svg>

                                    Receive
                                </button>

                                <button
                                    v-if="
                                        activeBtn === 'Button1' &&
                                        data.remarks?.substring(0, 19) ===
                                            'CHANGE CIVIL STATUS'
                                    "
                                    type="button"
                                    class="flex w-full items-center justify-center gap-2 rounded-xl bg-[#12760A] px-6 py-3 text-sm font-semibold text-white shadow-lg shadow-green-900/15 transition hover:bg-[#0B6014] focus:outline-none focus:ring-4 focus:ring-green-200 sm:w-auto"
                                    @click="updateCivilStatus"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        class="h-4 w-4"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                        stroke-width="2"
                                    >
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            d="M12 20h9"
                                        />

                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            d="M16.5 3.5a2.1 2.1 0 013 3L8 18l-4 1 1-4L16.5 3.5z"
                                        />
                                    </svg>

                                    Update Civil Status
                                </button>
                            </div>
                        </div>
                    </div>
                </Transition>
            </div>
            </Transition>
    </div>

    <!-- <div v-if="test">
        <div @click="test = false" class="w-full h-[150%] fixed top-0 left-0 bg-[#00000063] z-30 backdrop-blur-[2px]">
        </div>
        <div class="flex fixed justify-center top-[20%] bottom-[20%]  left-[10%] right-[10%] items-center  z-40">
            <div class="flex flex-col justify-center  z-40 bg-white w-[800px] text-lg rounded-lg border-[2px] border-[#006A00] relative">
                <div class="pafcpic_header bg-[#006A00] py-3 px-6">
                    <p class="text-[#ffffff] text-md font-bold">OHR Form Request</p>
                </div>
                <div class="pafcpic_body py-6 px-6">
                    <p class="text-green-800"></p>
                    <table>
                        <tr>
                            <td class="text-sm font-medium text-[#0B6014]">Employee</td>
                            <td class="text-sm font-medium">:</td>
                            <td class="text-sm px-3">{{ data.employee_name }}</td>
                        </tr>
                        <tr class="">
                            <td class="text-sm font-medium text-[#0B6014] pt-1">Date</td>
                            <td class="text-sm font-medium">:</td>
                            <td class="text-sm pt-1 px-3">{{ data.date_submitted}}</td>
                        </tr>
                        <tbody v-if="data.remarks?.substring(0, 19) != 'CHANGE CIVIL STATUS'">
                            <tr v-if="testser && Array.isArray(testser) && testser.length > 0" class="">
                                <td class="text-sm font-medium text-[#0B6014] align-top pt-1">Requests</td>
                                <td class="text-sm font-medium align-top pt-1">:</td>
                                <td class="text-sm pt-1 px-3">
                                    <div class="flex flex-col gap-1 pb-1">
                                        <span class="" v-for="(row,index) in testser" :key="index">{{ row.forms }}</span>
                                    </div>
                                </td>
                            </tr>
                            <tr  v-if="data.oth_reason != null && data.oth_reason != ''" class="">
                                <td class="text-sm font-medium text-[#0B6014] align-top pt-1">Other Requests</td>
                                <td class="text-sm font-medium align-top pt-1">:</td>
                                <td class="text-sm pt-1">
                                    <div class="flex flex-col gap-1 pb-1">
                                        <span class="" >{{data.oth_reason}}</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td class="text-sm font-medium text-[#0B6014]">Reason</td>
                                <td class="text-sm font-medium">:</td>
                                <td class="text-sm px-3">{{ data.reason }}</td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td class="text-sm font-medium text-[#0B6014]">Civil Status</td>
                                <td class="text-sm font-medium">:</td>
                                <td class="text-sm px-3">{{ data.remarks }}</td>
                            </tr>
                            <tr>
                                <td class="text-sm font-medium text-[#0B6014]">File Attachment</td>
                                <td class="text-sm font-medium">:</td>
                                <td class="text-sm px-3 text-[#d4d4d4] hover:text-[#706f6f] cursor-pointer" @click="getPdfFile(data.request_key)"> Click this to view the Attachment</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            <div class="pafcpic_footer flex gap-4 justify-end px-5 py-3 border-[#00800048] border-t font-medium">
                <button v-if="activeBtn === 'Button1' && data.remarks?.substring(0, 19) != 'CHANGE CIVIL STATUS'" class="text-sm text-white bg-green-800 py-1.5 px-7 rounded-md" v-on:click="ReleaseDocument">Receive</button>
                <button v-if="activeBtn === 'Button1' && data.remarks?.substring(0, 19) == 'CHANGE CIVIL STATUS'"  class="text-sm text-white bg-green-800 py-1.5 px-7 rounded-md" v-on:click="updateCivilStatus">Update Civil Status</button>
                <button class="text-sm text-[#6A6A6A] bg-[#D9D9D9] py-1.5 px-7 rounded-md" v-on:click="test = false">Cancel</button>
            </div>
        </div>
        </div>
    </div> -->
    
    <div v-if="hrReceive">
        <Prompt type="HRRECEIVED" @close="hrReceive = false"/>
    </div>

        

    </template>
    <script>
    import Prompt from "../Prompt/RequestPromt.vue"
    import { defineComponent } from 'vue';
    import TableControl from '.././TableControl/TableControl.vue'
    import Services from '../../../services/admin' 
    import Req from '../../../services/requestform' 
    export default defineComponent(
    {
        components:{
            TableControl,
            Prompt
        },
        data(){ 
            return{
                source: null,
                hrReceive:      false,
                activeBtn:      "Button1",
                info:           null,
                test:           false,
                request_key:    '',
                data:           '',
                infoapproved:   '',
                testser:'',
            
                columnapproved:[
                   
                    'employee_name',
                    'date_submitted',
                    'processed_date',
                    'processed_by',
                    'hr_status'
                ],
                header:[
                    {title:'Reference No.'},
                    {title:'Employee Name'},
                    {title:'Date Filed'},
                    {title:'Status'},
                    {title:'Action'},
                  
                    
                ],
                header1:[
                    {title:'Employee Name'},
                    {title:'Date Requested'},
                    {title:'Release Date'},
                    {title:'Processed by'},
                    {title:'Status'},
                    {title:'Action'},
                    
                ],
                column:[
                    'request_key',
                    'employee_name',
                    'date_submitted',
                    'hr_status',
                ],


            }
         },
        mounted(){
            this.GetHRrequestform();
        },
        methods:{
            async updateCivilStatus(){
                this.$emit("showLoader")
                let that = this
                await Req.updateCivilStatus(this.request_key).then(async function(){
                    await that.GetHRrequestform();
                    that.test               = false
                    that.hrReceive          = true
                }).catch(function(){

                });
                this.$emit("hideLoader")
            },
            async GetHRrequestform(){
                this.$emit("showLoader")
                const success = await Services.getRequestForms();
                this.info = success.data
                const approved = await Services.getApprovedRequestForms();
                this.infoapproved = approved.data
                this.$emit("hideLoader")

            },

            async getPdfFile(req_key){
                this.$emit("showLoader")
                let that = this
                await Req.getFile(req_key).then(function(response){
                    that.source = response.data.data.freq_doc
                    that.openAttachement()
                });
                this.$emit("hideLoader")
            },
            openAttachement(){
                if (!this.source) {
                    alert("No source data available.")
                    console.error("No source data available.");
                    return;
                }

                let pdfWindow = window.open("","_blank");
                setTimeout(() => {
                pdfWindow.document.write(
                "<iframe allowfullscreen='true' width='100%' height='100%' style='margin:0 0 0 0; padding:0 0 0 0; border: none; outline: none; position: fixed; top:0;right:0' src='" +
                    encodeURI(this.source) + "'></iframe>");}, 1000);
            },
            async ViewButton(row){
                this.$emit("showLoader")
                this.testser = ''
                const success = await Services.getRequestFormsbyid(row.request_key);
                this.testser = success.data
                this.request_key = row.request_key
                this.test = true
                this.data = row
                this.$emit("hideLoader")
            },
            async ReleaseDocument(){
                this.$emit("showLoader")
                let state               = this.$store.state
                const success           = await Services.approvedRequestForms(this.request_key,state.employee_key);
                this.testser            = success.data
                this.GetHRrequestform();
                this.test               = false
                this.$emit("hideLoader")
                this.hrReceive          = true
                
            } 
        },
    })
    </script>
    

    <style scoped>
    .active {

        color: #ffffff;
        background-color: #24723b;
      
      }
      .notactive {
        background-color: #CCAF12;
        color: #ececec;
      }

    </style>
  